import { useSelector } from 'react-redux';

import { getActiveDeal } from '../activeDeal/selector';
import type { SalesCheckinRootState } from '../common/types/SalesCheckinRootState';

/**
 * Hook to check if credit app is completed
 * Follows the same pattern as useTradeInComponent
 *
 * Credit app is considered completed when both dealRefId AND creditAppId exist.
 * These IDs are populated from:
 * 1. User completing credit app in current session (CREDIT_APP_SUBMITTED)
 * 2. Init API response (GET_DETAILS_SUCCESS)
 * 3. Checkin API response (CHECKIN_SUCCESS)
 *
 * Expected API Response Structure (init/checkin):
 * {
 *   data: {
 *     dealRefId: "string",
 *     creditApp: {
 *       creditAppId: "string",
 *       dealRefId: "string",
 *       status: "SUBMITTED" | "PENDING",
 *       shopper: {...}
 *     }
 *   }
 * }
 */
export const useCreditAppSelector = () => {
    const isCreditAppCompleted = useSelector((state: any) => {
        // Credit app state is stored at state.creditApp (not state.salesCheckin.creditApp)
        const creditApp = state?.creditApp || {};
        const { dealRefId, creditAppId } = creditApp;

        // Credit app is completed when we have both IDs (from any source)
        const activeDeal = getActiveDeal(state || ({} as SalesCheckinRootState));
        const persistedCreditApplicationId = activeDeal.dealStructure?.creditApplication?.creditApplicationId;
        const persistedDealRefId = activeDeal.coxAutoReferences?.dealRefId;

        return !!(dealRefId && creditAppId) || !!(persistedDealRefId && persistedCreditApplicationId);
    });

    return { isCreditAppCompleted };
};

export const isCreditAppCompleted = (): boolean => true;
